module.exports = __webpack_public_path__ + "static/media/2.PahaAyam.f2534816.jpeg";